import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'EN', full: 'English' },
  { code: 'hi', label: 'हि', full: 'हिंदी' },
  { code: 'mr', label: 'म', full: 'मराठी' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language;

  const switchLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('mpg_language', code);
  };

  return (
    <div style={{ display: 'flex', gap: '4px', padding: '8px 16px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      {LANGUAGES.map(lang => (
        <button
          key={lang.code}
          onClick={() => switchLang(lang.code)}
          title={lang.full}
          style={{
            flex: 1,
            padding: '5px 4px',
            borderRadius: '6px',
            border: 'none',
            background: current === lang.code ? 'rgba(255,107,0,0.9)' : 'rgba(255,255,255,0.08)',
            color: current === lang.code ? 'white' : 'rgba(255,255,255,0.5)',
            fontSize: '11px',
            fontWeight: 700,
            cursor: 'pointer',
            transition: 'all 0.15s',
            fontFamily: "'Nunito', sans-serif",
          }}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
